@if (!showingCode) {
  <pp-password-update-new-password-page
    [(ppPasswordResetUser)]="passwordResetUser"
    [ppProcessing]="isProcessing"
    (ppUpdate)="updatePassword()"
  ></pp-password-update-new-password-page>
}

@if (showingCode) {
  <pp-two-factor-authentication-code-page
    [ppPhoneNumber]="phoneNumber"
    [ppProcessing]="isProcessing"
    (ppConfirm2FA)="updatePassword($event)"
    (ppGoBack)="goToPasswordChange()"
    [ppErrorMessage]="errorMessage"
    (ppResend)="resendCode()"
  ></pp-two-factor-authentication-code-page>
}
